export function DashboardCbsIcon(props) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M13.1622 1H6.83784C3.61369 1 1 3.61369 1 6.83784V13.1622C1 16.3863 3.61369 19 6.83784 19H13.1622C16.3863 19 19 16.3863 19 13.1622V6.83784C19 3.61369 16.3863 1 13.1622 1Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M5.13525 12.9199L7.51904 9.74798C7.66501 9.55265 7.87902 9.41925 8.11867 9.37421C8.35832 9.32916 8.60615 9.37574 8.81309 9.50473L11.1385 10.9739C11.3534 11.1108 11.6134 11.1579 11.8626 11.1051C12.1119 11.0524 12.3305 10.9039 12.4715 10.6918L14.865 7.08203"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
